import api from './base';

/**
 * Get user's saved addresses
 */
export const getAddresses = async () => {
  const response = await api.get('/checkout/addresses');
  return response.data;
};

/**
 * Add a new address
 */
export const addAddress = async (addressData) => {
  const response = await api.post('/checkout/addresses', addressData);
  return response.data;
};

/**
 * Update an existing address
 */
export const updateAddress = async (addressId, addressData) => {
  const response = await api.put(`/checkout/addresses/${addressId}`, addressData);
  return response.data;
};

/**
 * Delete an address
 */
export const deleteAddress = async (addressId) => {
  const response = await api.delete(`/checkout/addresses/${addressId}`);
  return response.data;
};

/**
 * Set address as default
 */
export const setDefaultAddress = async (addressId) => {
  const response = await api.put(`/checkout/addresses/${addressId}/default`);
  return response.data;
};

/**
 * Get order summary
 */
export const getOrderSummary = async (shippingPincode = null, customerType = 'B2C') => {
  const params = {};
  if (shippingPincode) params.shippingPincode = shippingPincode;
  if (customerType) params.customerType = customerType;
  
  const response = await api.get('/checkout/summary', { params });
  return response.data;
};

/**
 * Create a new order
 */
export const createOrder = async (orderData) => {
  // console.log('📦 API: Creating order with data:', orderData);
  const response = await api.post('/checkout/place-order', orderData);
  return response.data;
};

/**
 * Apply coupon
 */
export const applyCoupon = async (couponCode) => {
  const response = await api.post('/checkout/apply-coupon', { couponCode });
  return response.data;
};

/**
 * Remove coupon
 */
export const removeCoupon = async (couponCode) => {
  const response = await api.post('/checkout/remove-coupon', { couponCode });
  return response.data;
};

/**
 * Get shipping options
 */
export const getShippingOptions = async (pincode, weight, totalAmount) => {
  const response = await api.get('/checkout/shipping-options', {
    params: { pincode, weight, totalAmount }
  });
  return response.data;
};
